import React, { useEffect, useState } from 'react';
import { Phone, Menu as MenuIcon, X } from 'lucide-react';
import { RESTAURANT, NAV_LINKS } from '../mock';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-9 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#100d0b]/92 backdrop-blur-md border-b border-[rgba(224,180,159,0.12)] py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
        <a href="#top" className="flex flex-col leading-none">
          <span className="font-serif-display text-2xl md:text-[26px] tracking-[0.22em] text-[#f2ebe3] pl-[0.22em]">
            {RESTAURANT.name}
          </span>
          <span className="eyebrow text-[0.6rem] mt-1 pl-1">{RESTAURANT.place}</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="eyebrow text-[#d9cfc4] hover:text-[#e0b49f] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={RESTAURANT.phoneHref}
            className="hidden sm:flex items-center gap-2 rounded-full border border-[rgba(224,180,159,0.45)] text-[#f2ebe3] px-5 py-2.5 text-sm font-medium hover:bg-[#e0b49f] hover:text-[#1a1410] hover:border-[#e0b49f] transition-all duration-300"
          >
            <Phone size={15} />
            <span className="tracking-wide">{RESTAURANT.phone}</span>
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden text-[#f2ebe3] p-1"
            aria-label="Menü"
          >
            {open ? <X size={26} /> : <MenuIcon size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-[#100d0b]/98 backdrop-blur-md border-t border-[rgba(224,180,159,0.12)] mt-3">
          <nav className="flex flex-col px-6 py-5 gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="eyebrow text-[#d9cfc4] hover:text-[#e0b49f] py-1"
              >
                {l.label}
              </a>
            ))}
            <a href={RESTAURANT.phoneHref} className="flex items-center gap-2 text-[#e0b49f] pt-2">
              <Phone size={15} /> {RESTAURANT.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
